module.exports = __webpack_public_path__ + "images/vkb_logo.svg?e2c9617c2457f33c59b57f56c27b0b55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_logo.svg
// module id = aX6B
// module chunks = 0